var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 536px;\n  margin: 32px;\n'], ['\n  width: 536px;\n  margin: 32px;\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n']),
  _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n'], ['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n']),
  _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n'], ['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n']),
  _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-weight: 700;\n  font-family: \'Nunito Sans\';\n'], ['\n  font-weight: 700;\n  font-family: \'Nunito Sans\';\n']),
  _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n']),
  _templateObject8 = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  line-height: 1.5;\n  font-size: 16px;\n  margin-right: 32px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n'], ['\n  text-decoration: none;\n  line-height: 1.5;\n  font-size: 16px;\n  margin-right: 32px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n']),
  _templateObject9 = _taggedTemplateLiteralLoose(['\n  max-width: 144px;\n'], ['\n  max-width: 144px;\n']);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Title, Text, RadioInput, Button, Icon, Link } from '@olxbr/design-system/web';
import { sendQualtricsEvent } from '@olxbr/react-qualtrics';
import { DeleteReason, Step } from '../constants';
import DeletionService from '../services/AdDeletionService';
import { sendEvent } from '../util/tracking';
var DivCustom = styled.div(_templateObject, function (_ref) {
  var mb = _ref.mb,
    color = _ref.color;
  var style = '';
  if (mb) {
    style += 'margin-bottom: ' + mb + 'px;';
  }
  if (color) {
    style += 'color: ' + color + ';';
  }
  return style;
});
var ContainerDiv = styled.div(_templateObject2);
var CloseModal = styled.div(_templateObject3);
var TitleCustom = styled(Title)(_templateObject4);
var TextDiv = styled(Text)(_templateObject5);
var Bold = styled.span(_templateObject6);
var ButtonDiv = styled.div(_templateObject7);
var LinkCustom = styled(Link)(_templateObject8);
var ButtonWithoutFlex = styled(Button)(_templateObject9);
var DeleteAd = function (_React$Component) {
  _inherits(DeleteAd, _React$Component);
  function DeleteAd() {
    var _temp, _this, _ret;
    _classCallCheck(this, DeleteAd);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.deleteAndContinue = function () {
      var _this$props$values = _this.props.values,
        listId = _this$props$values.listId,
        reason = _this$props$values.reason;
      switch (reason) {
        case DeleteReason.SOLD_BY_OLX:
        case DeleteReason.SOLD_BY_OTHER:
          if (reason === DeleteReason.SOLD_BY_OLX) {
            sendQualtricsEvent('sold_ad');
          }
          DeletionService.deleteAd(listId, reason).then(function () {
            _this.props.nextStep(Step.AD_DELETED);
          }).catch(function (errorMessage) {
            console.log(errorMessage);
            _this.props.nextStep(Step.DELETE_ERROR);
          });
          break;
        case DeleteReason.NOT_SOLD:
        case DeleteReason.OTHER_REASON:
          _this.props.nextStep(Step.BUMP);
          break;
        // no default
      }
      sendEvent({
        event_type: 'click',
        object_detail: 'confirm_delete_button',
        object_name: 'ad_deleting',
        data: {
          reason: _this.props.values.reason,
          listId: _this.props.values.listId
        }
      });
    }, _this.deleteWithNoSurvey = function () {
      var adId = _this.props.values.adId;
      var reason = DeleteReason.OTHER_REASON;
      DeletionService.deleteAdByAdId(adId, reason).then(function () {
        _this.props.nextStep(Step.AD_DELETED);
      }).catch(function (errorMessage) {
        console.log(errorMessage);
        _this.props.nextStep(Step.DELETE_ERROR);
      });
      sendEvent({
        event_type: 'click',
        object_detail: 'confirm_delete_button',
        object_name: 'ad_deleting',
        data: {
          reason: reason,
          adId: adId
        }
      });
    }, _this.isChecked = function (deleteReason) {
      return _this.props.values.reason === deleteReason;
    }, _this.onChangeValue = function (reason, detail) {
      return function () {
        _this.props.handleChange({
          target: {
            name: 'reason',
            value: reason
          }
        });
        sendEvent({
          event_type: 'click',
          object_detail: detail,
          object_name: 'ad_deleting'
        });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  DeleteAd.prototype.componentDidMount = function componentDidMount() {
    sendEvent({
      event_type: 'page_view',
      object_detail: 'step_delete_ad',
      object_name: 'ad_deleting'
    });
  };

  // Used by PENDING_PAY tab

  DeleteAd.prototype.render = function render() {
    var _this2 = this;
    var noSurvey = this.props.noSurvey;
    if (noSurvey) {
      return React.createElement(ContainerDiv, null, React.createElement(CloseModal, null, React.createElement(Link, {
        href: '',
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.props.closeModal('ad_deleting');
        }
      }, React.createElement(Icon, {
        svgPath: 'M13.0606602,12 L18.5303301,17.4696699 C18.8232233,17.7625631 18.8232233,18.2374369 18.5303301,18.5303301 C18.2374369,18.8232233 17.7625631,18.8232233 17.4696699,18.5303301 L12,13.0606602 L6.53033009,18.5303301 C6.23743687,18.8232233 5.76256313,18.8232233 5.46966991,18.5303301 C5.1767767,18.2374369 5.1767767,17.7625631 5.46966991,17.4696699 L10.9393398,12 L5.46966991,6.53033009 C5.1767767,6.23743687 5.1767767,5.76256313 5.46966991,5.46966991 C5.76256313,5.1767767 6.23743687,5.1767767 6.53033009,5.46966991 L12,10.9393398 L17.4696699,5.46966991 C17.7625631,5.1767767 18.2374369,5.1767767 18.5303301,5.46966991 C18.8232233,5.76256313 18.8232233,6.23743687 18.5303301,6.53033009 L13.0606602,12 Z',
        width: 24,
        height: 24
      }))), React.createElement(DivCustom, {
        mb: 8
      }, React.createElement(TitleCustom, null, 'Excluir an\xFAncio')), React.createElement(DivCustom, {
        mb: 18
      }, React.createElement(TextDiv, {
        tag: 'span'
      }, 'Tem certeza que deseja excluir o an\xFAncio "', this.props.values.title, '"? Ap\xF3s a exclus\xE3o, voc\xEA perder\xE1 as informa\xE7\xF5es do an\xFAncio e o seu limite da categoria n\xE3o vai ser recuperado.')), React.createElement(ButtonDiv, null, React.createElement(LinkCustom, {
        type: 'primary',
        href: '',
        onClick: function onClick(e) {
          e.preventDefault();
          sendEvent({
            event_type: 'click',
            object_detail: 'step_delete_ad_dismiss',
            object_name: 'ad_deleting'
          });
          _this2.props.closeModal();
        }
      }, 'Cancelar'), React.createElement(ButtonWithoutFlex, {
        size: 'medium',
        fluid: true,
        onClick: this.deleteWithNoSurvey
      }, 'Excluir')));
    }
    return React.createElement(ContainerDiv, null, React.createElement(CloseModal, null, React.createElement(Link, {
      href: '',
      onClick: function onClick(e) {
        e.preventDefault();
        _this2.props.closeModal('ad_deleting');
      }
    }, React.createElement(Icon, {
      svgPath: 'M13.0606602,12 L18.5303301,17.4696699 C18.8232233,17.7625631 18.8232233,18.2374369 18.5303301,18.5303301 C18.2374369,18.8232233 17.7625631,18.8232233 17.4696699,18.5303301 L12,13.0606602 L6.53033009,18.5303301 C6.23743687,18.8232233 5.76256313,18.8232233 5.46966991,18.5303301 C5.1767767,18.2374369 5.1767767,17.7625631 5.46966991,17.4696699 L10.9393398,12 L5.46966991,6.53033009 C5.1767767,6.23743687 5.1767767,5.76256313 5.46966991,5.46966991 C5.76256313,5.1767767 6.23743687,5.1767767 6.53033009,5.46966991 L12,10.9393398 L17.4696699,5.46966991 C17.7625631,5.1767767 18.2374369,5.1767767 18.5303301,5.46966991 C18.8232233,5.76256313 18.8232233,6.23743687 18.5303301,6.53033009 L13.0606602,12 Z',
      width: 24,
      height: 24
    }))), React.createElement(DivCustom, {
      mb: 8
    }, React.createElement(TitleCustom, null, 'Excluir an\xFAncio')), React.createElement(DivCustom, {
      mb: 18
    }, React.createElement(TextDiv, {
      tag: 'span'
    }, 'Antes de excluir o an\xFAncio "', this.props.values.title, '", conta para a gente:', ' ', React.createElement(Bold, null, 'conseguiu vender'), ' este item?')), React.createElement(DivCustom, {
      mb: 32,
      color: '#4a4a4a'
    }, React.createElement(DivCustom, {
      mb: 14
    }, React.createElement(RadioInput, {
      label: 'Vendi pela OLX',
      checked: this.isChecked(DeleteReason.SOLD_BY_OLX),
      value: DeleteReason.SOLD_BY_OLX,
      name: 'reason',
      onChange: this.onChangeValue(DeleteReason.SOLD_BY_OLX, 'reason_sold_olx')
    })), React.createElement(DivCustom, {
      mb: 14
    }, React.createElement(RadioInput, {
      label: 'Vendi por outro meio',
      checked: this.isChecked(DeleteReason.SOLD_BY_OTHER),
      value: DeleteReason.SOLD_BY_OTHER,
      name: 'reason',
      onChange: this.onChangeValue(DeleteReason.SOLD_BY_OTHER, 'reason_sold_other')
    })), React.createElement(DivCustom, {
      mb: 14
    }, React.createElement(RadioInput, {
      label: 'Ainda n\xE3o vendi',
      checked: this.isChecked(DeleteReason.NOT_SOLD),
      value: DeleteReason.NOT_SOLD,
      name: 'reason',
      onChange: this.onChangeValue(DeleteReason.NOT_SOLD, 'reason_not_sold')
    })), React.createElement(DivCustom, null, React.createElement(RadioInput, {
      label: 'Outro',
      checked: this.isChecked(DeleteReason.OTHER_REASON),
      value: DeleteReason.OTHER_REASON,
      name: 'reason',
      onChange: this.onChangeValue(DeleteReason.OTHER_REASON, 'reason_other')
    }))), React.createElement(ButtonDiv, null, React.createElement(LinkCustom, {
      type: 'primary',
      href: '',
      onClick: function onClick(e) {
        e.preventDefault();
        sendEvent({
          event_type: 'click',
          object_detail: 'step_delete_ad_dismiss',
          object_name: 'ad_deleting'
        });
        _this2.props.closeModal();
      }
    }, 'Cancelar'), React.createElement(ButtonWithoutFlex, {
      size: 'medium',
      fluid: true,
      onClick: this.deleteAndContinue,
      disabled: !this.props.values.reason
    }, 'Excluir')));
  };
  return DeleteAd;
}(React.Component);
DeleteAd.propTypes = process.env.NODE_ENV !== "production" ? {
  closeModal: PropTypes.func,
  nextStep: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.object,
  noSurvey: PropTypes.bool
} : {};
export default DeleteAd;